import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useLocale } from '../../shared/i18n/LocaleContext'

export function CompanySelectionPage() {
  const { user, selectCompany } = useAuth()
  const { t } = useLocale()
  const navigate = useNavigate()
  const [busyId, setBusyId] = useState<string | null>(null)
  const [error, setError] = useState(false)

  if (!user) return null

  const activate = async (companyId: string) => {
    if (companyId === user.activeCompanyId) return
    setBusyId(companyId)
    setError(false)
    try {
      await selectCompany(companyId)
      navigate('/app/inicio', { replace: true })
    } catch {
      setError(true)
    } finally {
      setBusyId(null)
    }
  }

  return <main className="page-content company-selection-page">
    <header className="welcome administration-heading">
      <div>
        <span className="eyebrow">{t('user.companyContext')}</span>
        <h1>{t('user.selectCompany')}</h1>
        <p>{user.configurationName} · {t('user.selectCompanyHelp')}</p>
      </div>
    </header>
    {error && <p className="form-error">{t('administration.companyAccessDenied')}</p>}
    <section className="data-panel administration-panel company-selection-panel">
      <div className="section-heading">
        <h2>{t('administration.assignedCompanies')}</h2>
        <kbd>Ctrl + 0</kbd>
      </div>
      <div className="company-selection-grid">
        {user.companies.map(company => {
          const active = company.id === user.activeCompanyId
          return <article className={`company-selection-card ${active ? 'active' : ''}`} key={company.id}>
            <span className="company-selection-mark" aria-hidden="true">{company.code.slice(0, 1)}</span>
            <div className="company-selection-copy">
              <strong>{company.code}</strong>
              <span>{company.name}</span>
            </div>
            {active
              ? <span className="status-pill active">{t('user.activeCompany')}</span>
              : <button className="primary-button" disabled={busyId !== null} type="button"
                  onClick={() => void activate(company.id)}>
                  {busyId === company.id ? t('administration.loading') : t('user.activateCompany')}
                </button>}
          </article>
        })}
      </div>
    </section>
  </main>
}
